<template>
	<Header />
	<div class="main-section">
		<router-view v-slot="{ Component }">
			<keep-alive :exclude="doNotKeep">
				<component :is="Component" :key="doNotKeep.includes($route.name) ? $route.fullPath : undefined" />
			</keep-alive>
		</router-view>
	</div>
	<Footer />
</template>
<script setup>
import { getCurrentInstance } from "vue";
import { useStore } from "vuex";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

const store = useStore();
const globalProperties = getCurrentInstance().appContext.config.globalProperties;
const doNotKeep = ["Product", "Promotion", "Optional", "Cart", "Member", "Search", "Page"];
if (!globalProperties.isServer) {
	store.commit("setIsMobileDevice", window.innerWidth);
	window.addEventListener(("resize"), () => {
		store.commit("setIsMobileDevice", window.innerWidth);
	});
}
</script>